// extracted by mini-css-extract-plugin
export default {"container":"flight-review_container__wAJgd","content":"flight-review_content__ufUx-"};